.c6{display:inline-flex;}